import React, { useState, useEffect } from 'react';
import { ArrowRight, CheckCircle, Leaf } from 'lucide-react';

const HeroBold = () => {
  const [currentImage, setCurrentImage] = useState(0);
  
  const images = [
    'https://images.unsplash.com/photo-1606951955990-c8f0282c6d4e?q=80&w=2000',
    'https://images.unsplash.com/photo-1758055660285-d32b7b3b1e77?q=80&w=2000',
    'https://images.unsplash.com/photo-1624351251625-cf02b018223c?q=80&w=2000',
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {images.map((img, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentImage ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={img}
            alt="Organic products"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-orange-900/90 via-red-900/85 to-yellow-900/80"></div>
        </div>
      ))}

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-3 px-6 py-3 bg-yellow-400 text-orange-900 rounded-lg mb-8 shadow-2xl">
            <Leaf className="animate-pulse" size={24} />
            <span className="font-bold text-lg">NPOP CERTIFIED ORGANIC EXPORTER</span>
          </div>

          <h1 className="text-6xl sm:text-7xl lg:text-8xl font-black mb-6 leading-tight">
            <span className="text-white drop-shadow-[0_4px_20px_rgba(0,0,0,0.8)]">
              INDIA'S FINEST
            </span>
            <span className="block text-yellow-300 drop-shadow-[0_4px_20px_rgba(0,0,0,0.8)] mt-2">
              ORGANIC EXPORTS
            </span>
          </h1>

          <p className="text-2xl sm:text-3xl text-yellow-50 mb-8 leading-relaxed font-semibold drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]">
            Premium turmeric, ginger, buckwheat & black cardamom from certified organic farms
          </p>

          <div className="grid grid-cols-2 gap-4 mb-10">
            {[
              '🌿 Turmeric (Powder & Flakes)',
              '🫚 Ginger (Powder & Flakes)',
              '🌾 Organic Buckwheat',
              '🫘 Black Cardamom'
            ].map((product, index) => (
              <div key={index} className="bg-yellow-400/20 backdrop-blur-md border-2 border-yellow-300 rounded-xl p-4">
                <p className="text-white font-bold text-lg drop-shadow-lg">{product}</p>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#products"
              className="inline-flex items-center justify-center px-10 py-5 bg-yellow-400 text-orange-900 rounded-xl font-black text-xl shadow-2xl hover:bg-yellow-300 transform hover:scale-105 transition-all duration-300"
            >
              EXPLORE PRODUCTS
              <ArrowRight className="ml-3" size={28} />
            </a>
            <a
              href="#contact"
              className="inline-flex items-center justify-center px-10 py-5 bg-white/20 backdrop-blur-md border-3 border-white text-white rounded-xl font-bold text-xl hover:bg-white hover:text-orange-900 transition-all duration-300"
            >
              GET WHOLESALE QUOTE
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-10 right-10 text-yellow-300/30 hidden lg:block">
        <Leaf size={200} style={{animation: 'spin 20s linear infinite'}} />
      </div>
    </section>
  );
};

export default HeroBold;